/* London & Co. — predictive search (§16).
   Fetches Shopify's suggest endpoint with `section_id` so the markup — and,
   importantly, the money formatting and display_title lookups — are produced
   by Liquid rather than reassembled here. This file only moves HTML around and
   handles the keyboard. */
(function () {
  var SECTION = 'predictive-search';
  var DEBOUNCE = 220;
  var MIN = 2;

  function wire(input, panel) {
    if (!input || !panel || input.dataset.lcPredWired) return;
    input.dataset.lcPredWired = 'true';

    var timer = null;
    var controller = null;
    var activeIndex = -1;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');
    if (panel.id) input.setAttribute('aria-controls', panel.id);

    function items() {
      return Array.prototype.slice.call(panel.querySelectorAll('[data-lc-pred-item]'));
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function highlight(next) {
      var list = items();
      if (!list.length) return;
      if (activeIndex > -1 && list[activeIndex]) list[activeIndex].classList.remove('is-active');
      activeIndex = next;
      if (activeIndex < 0) activeIndex = list.length - 1;
      if (activeIndex >= list.length) activeIndex = 0;
      var el = list[activeIndex];
      el.classList.add('is-active');
      el.scrollIntoView({ block: 'nearest' });
    }

    function run(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.predictive_search_url
        ? window.Shopify.routes.predictive_search_url
        : '/search/suggest';
      var href = url
        + '?q=' + encodeURIComponent(q)
        + '&section_id=' + SECTION
        + '&resources[type]=product,collection'
        + '&resources[limit]=10';

      fetch(href, { signal: controller.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          /* The endpoint returns the whole section wrapper; take its contents. */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.lc-pred__inner');
          if (!inner) { close(); return; }
          panel.innerHTML = inner.outerHTML;
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          activeIndex = -1;
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          /* A failed suggestion must never block the real search. */
          close();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN) { close(); return; }
      timer = setTimeout(function () { run(q); }, DEBOUNCE);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(activeIndex - 1); }
      else if (e.key === 'Escape') {
        if (!panel.hidden) { e.stopPropagation(); close(); }
      } else if (e.key === 'Enter') {
        var list = items();
        if (activeIndex > -1 && list[activeIndex]) {
          e.preventDefault();
          window.location.href = list[activeIndex].getAttribute('href');
        }
        /* Otherwise the form submits to the real results page, as it should. */
      }
    });

    document.addEventListener('click', function (e) {
      if (panel.contains(e.target) || e.target === input) return;
      close();
    });
  }

  function init() {
    document.querySelectorAll('[data-lc-pred-panel]').forEach(function (panel) {
      var scope = panel.closest('[data-lc-search-scope]') || document;
      wire(scope.querySelector('input[type="search"]'), panel);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();